(function () {
  // La variante du gilet est lue automatiquement depuis Shopify (plus d'ID écrit en dur)
  var PRODUCT_HANDLE = 'gilet-de-trail-trakflow-zero-rebond';
  function getVariantId() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    var handle = m ? m[1] : PRODUCT_HANDLE;
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Produit introuvable'); return r.json(); })
      .then(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        return v.id;
      });
  }
  // Offres dans l'ordre des cartes : quantité + nom affiché dans le panier
  var OFFERS = [
    { qty: 1, name: 'Pack Solo (1 gilet)' },
    { qty: 2, name: 'Pack Duo (2 gilets)' },
    { qty: 3, name: 'Pack Famille (3 gilets)' }
  ];

  function initBundle() {
    var cards = document.querySelectorAll('.tf-bundle-card');
    if (!cards.length) return;

    function getOffer(card) {
      var i = Array.prototype.indexOf.call(cards, card);
      return OFFERS[i] || OFFERS[0];
    }

    function selectCard(card) {
      cards.forEach(function (c) { c.classList.remove('active'); });
      card.classList.add('active');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
    });

    // Pré-sélection via URL : ?offre=duo / ?offre=famille (ou anciens liens ?variant=...)
    var urlParams = new URLSearchParams(window.location.search);
    var offre = (urlParams.get('offre') || '').toLowerCase();
    var preVariant = urlParams.get('variant');
    var target = null;
    if (offre === 'solo') target = cards[0];
    if (offre === 'duo') target = cards[1];
    if (offre === 'famille') target = cards[2];
    if (!target && preVariant) {
      cards.forEach(function (card) { if (card.dataset.variant === preVariant) target = card; });
    }
    if (target) {
      selectCard(target);
      setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 300);
    }

    var btn = document.getElementById('tf-bundle-cta-btn');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var activeCard = document.querySelector('.tf-bundle-card.active') || cards[0];
      var offer = getOffer(activeCard);
      var orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Ajout en cours…';

      getVariantId()
        .then(function (variantId) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: offer.qty, properties: { 'Offre': offer.name } }] })
          });
        })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || ('HTTP ' + r.status));
            return data;
          });
        })
        .then(function () {
          btn.textContent = '✓ Ajouté au panier !';
          btn.style.background = '#16a34a';
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var cartLink = document.getElementById('cart-icon-bubble');
              var bubble = document.querySelector('.cart-count-bubble');
              if (!bubble && cartLink && cart.item_count > 0) {
                bubble = document.createElement('div');
                bubble.className = 'cart-count-bubble';
                var spanHidden = document.createElement('span');
                spanHidden.setAttribute('aria-hidden', 'true');
                var spanVisible = document.createElement('span');
                spanVisible.className = 'visually-hidden';
                bubble.appendChild(spanHidden);
                bubble.appendChild(spanVisible);
                cartLink.appendChild(bubble);
              }
              if (bubble) {
                var b = bubble.querySelector('span[aria-hidden]');
                if (b) b.textContent = cart.item_count;
                var s = bubble.querySelector('span:not([aria-hidden])');
                if (s) s.textContent = cart.item_count + ' article' + (cart.item_count > 1 ? 's' : '');
              }
            })
            .catch(function () {});
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = orig;
            btn.style.background = '';
          }, 2500);
        })
        .catch(function (err) {
          console.error('[Trakflow bundle]', err);
          btn.textContent = 'Oups, erreur — réessayez';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = orig;
          }, 2500);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundle);
  } else {
    initBundle();
  }
})();
